import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdKeyboardArrowDown, GiHamburgerMenu } from "../utils/Icons";
import { useAuthContext } from "../context/AuthContext";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";
import { useTestContext } from "../context/TestContext";
import { IoIosSearch, MdClose } from "../utils/Icons";
import { useBottomNavbarContext } from "../context/BottomNavBarContext";

const linksData = [
	{ title: "Blog", link: "/blogs" },
	{ title: "Contact Us", link: "/contact-us" },
	{ title: "About Us", link: "/about-us" },
];

const loggedInLinksData = [
	{ title: "My Profile", link: "/my-profile" },
	{ title: "My Order", link: "/my-order" },
	{ title: "Family Members", link: "/family-member" },
	{ title: "My Address", link: "/my-address" },
	{ title: "Support", link: "/support" },
];

const Navbar = ({
	scrollDirection = "",
	searchVisible = true,
	locationCardVisibility,
	locationCardStatus,
	locationVisibility = true,
}) => {
	const {
		setIsAuth,
		isLoggedIn,
		handleUserLogout,
		userData,
		isSearchVisible,
		isSidebar,
		//setIsSidebar,
		handleSidebarClick,
		saveCurrentLocation,
		//fetchUserAddress,
		userLocationAddress,
	} = useAuthContext();
	const { countAllCartProducts } = useOrderProcessingContext();
	const {
		fetchGlobalSearch,
		searchQuery,
		handleGlobalSearchChange,
		globalSearchData,
		globalSearchQuery,
		handleSearchClick,
		setProductsBySearchQuery,
		productsBySearchQuery,
		fetchProductsBySearchQuery,
		productsToBeSearched,
		handleAddProductsToBeSearched,
		handleRemoveProductsToBeSearched,
		fetchAllSearchedProducts,
		setGlobalSearchQuery,
		navbarSearchQuery,
		setNavbarSearchQuery,
	} = useTestContext();

	const {
		setIsHomeActive,
		setIsTestsActive,
		setIsPackagesActive,
		setIsRadiologyActive,
		setIsProfileActive,
	} = useBottomNavbarContext();

	const [profileHovered, setProfileHovered] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	// Handle cart click
	const handleCartClick = () => {
		navigate("/cart");
	};

	const handlePhoneFinelabsClick = () => {
		setIsHomeActive(true);
		setIsTestsActive(false);
		setIsPackagesActive(false);
		setIsRadiologyActive(false);
		setIsProfileActive(false);
		navigate("/");
	};

	// const handleLocationClick = () => {
	// 	locationCardVisibility((prev) => !prev);
	// };

	const handleLocationClick = () => {
		locationCardVisibility(true); // instead of toggling, mark as clicked
	};


	const handleLocationFetch = () => {
		saveCurrentLocation();
	};

	const handleSearchQueryChange = (e) => {
		setProductsBySearchQuery([]);
		setNavbarSearchQuery(e.target.value);
		if (e.target.value.length >= 3) {
			fetchProductsBySearchQuery(e.target.value);
		}
	};

	return (
		<>
			{/** Large Screens */}
			<div
				className={`w-full h-fit bg-whiteColor hidden 2xl:flex justify-between items-center px-[2%] py-2 fixed left-0 ${scrollDirection === "up" ? "top-10" : "top-0"
					} right-0 z-50`}>
				<div className='w-[50%] h-fit flex justify-start items-center space-x-[5%]'>
					<Link to='/'>
						<img
							src='/assets/finelabs-logo-blue.svg'
							alt='finelabs-logo'
							onClick={() => handleAddProductsToBeSearched([])}
						/>
					</Link>

					{locationVisibility && (
						<div className='w-[33%] h-fit flex flex-col justify-start items-center'>
							<div className='w-full h-9 bg-whiteColor flex justify-between items-center border-2 border-red-300 rounded-xl px-[5%] cursor-pointer relative'>
								<div
									className='flex items-center space-x-2'
									onClick={handleLocationClick}>
									<img
										src='/assets/location-pin.svg'
										alt='location-pin'
										className='w-[12.5%]'
									/>
									{userLocationAddress !== "" ? (
										<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor whitespace-nowrap'>
											{userLocationAddress?.slice(0, 20)}
										</p>
									) : (
										<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor whitespace-nowrap'>
											"Select Location..."
										</p>
									)}
								</div>
								<MdKeyboardArrowDown className='text-base text-textSecondaryColor' />
								{locationCardStatus && (
									<div className='w-full h-fit bg-whiteColor border rounded-xl shadow p-[5%] absolute left-0 right-0 top-10 z-50'>
										<div
											className='w-full h-fit flex items-center space-x-2'
											onClick={handleLocationFetch}>
											<img
												src='/assets/location-arrow.svg'
												alt='location-arrow'
												className='w-[7.5%]'
											/>
											<span className='font-normal text-[4vw] lg:text-[1vw] text-accentColor'>
												Use My Current Location
											</span>
										</div>
									</div>
								)}
							</div>
						</div>
					)}

					{isSearchVisible && searchVisible && (
						<div className='w-[95%] lg:w-[45%] h-[48px] bg-whiteColor border-2 border-blue-300 rounded-[32px] flex justify-between items-center  relative'>
							<div className='flex w-full items-center ml-[2%] overflow-y-scroll'>
								{productsToBeSearched.length == 0 && (
									<IoIosSearch className='text-xl text-blue-300 mr-[2%]' />
								)}
								{productsToBeSearched.length > 0 && (
									<div className='w-full h-11 ml-2 gap-y-2 gap-x-2 grid grid-cols-1 pt-2 mr-2'>
										{productsToBeSearched.map((product, index) => (
											<div
												key={index}
												className='w-full px-2 h-[28px] rounded-[28px] bg-[#E0E0E0] flex justify-between items-center mr-2 text-[13px] text-[#57636C]'>
												<div className='w-fit truncate'>{product}</div>
												<img
													src='/assets/close-icon.svg'
													alt='close-icon'
													className='cursor-pointer ml-1 flex-shrink-0'
													onClick={() =>
														handleRemoveProductsToBeSearched(product)
													}
												/>
											</div>
										))}
									</div>
								)}
								<input
									type='text'
									value={navbarSearchQuery}
									onChange={handleSearchQueryChange}
									placeholder='Search from 12,000+ Lab Tests, Packages, X-rays & Scans'
									className='w-[83%] h-full rounded-xl font-normal text-[14px] text-textPrimaryColor placeholder:text-[14px] outline-none'
								/>
							</div>
							<div
								className='flex justify-center items-center mr-[1%] text-[15px] text-white w-[120px] bg-gradient-to-r from-[#1A67D8] to-[#0047AF] h-[40px] rounded-[48px]'
								onClick={handleSearchClick}>
								Search
							</div>
							{navbarSearchQuery?.length > 0 &&
								productsBySearchQuery?.length > 0 && (
									<div className='w-full h-[33vh] bg-whiteColor  border rounded-3xl shadow py-[3%] mt-1 absolute left-0 right-0 top-14 z-50 overflow-scroll scrollbar-hide'>
										{productsBySearchQuery?.map((item, index) => (
											<div
												className='w-full h-fit flex justify-between items-center border-b px-[2%] py-[1%] cursor-pointer'
												key={index}
												onClick={() => handleAddProductsToBeSearched(item)}>
												<span className='font-normal text-[14px] text-textPrimaryColor'>
													{item}
												</span>
											</div>
										))}
									</div>
								)}
						</div>
					)}
				</div>
				<div className='w-[50%] h-fit flex justify-end items-center'>
					{linksData?.map((item, index) => (
						<Link
							to={item.link}
							key={index}
							className={`font-semibold text-[1vw] ${location.pathname === item.link
									? "text-primaryColor border-b-2 border-primaryColor"
									: "text-textPrimaryColor"
								} ml-[5%] hover:text-primaryColor hover:border-b-2 hover:border-primaryColor`}>
							{item.title}
						</Link>
					))}
					{isLoggedIn && userData?.name?.length > 0 ? (
						<div
							className='ml-[10%] relative'
							onMouseEnter={() => setProfileHovered(true)}
							onMouseLeave={() => setProfileHovered(false)}>
							<div className='flex items-center space-x-2 cursor-pointer'>
								<img
									src='/assets/user-icon.svg'
									alt='user-icon'
									className='w-9'
								/>
								<span className='font-semibold text-lg text-textPrimaryColor'>
									{userData?.name ? userData?.name.split(" ")[0] : "User"}
								</span>
								<MdKeyboardArrowDown className='text-lg text-textPrimaryColor' />
							</div>
							{profileHovered && (
								<div className='bg-whiteColor flex flex-col justify-start items-start border rounded-xl shadow space-y-[3%] absolute left-0 right-0 z-50'>
									<Link
										to='/my-profile'
										className='w-full h-fit font-normal text-[1vw] text-textPrimaryColor border-b pl-[7.5%] py-[5%]'>
										My Profile
									</Link>
									<Link
										to='/my-order'
										className='w-full h-fit font-normal text-[1vw] text-textPrimaryColor border-b pl-[7.5%] pt-[2.5%] pb-[5%]'>
										My Order
									</Link>
									<span
										className='w-full h-fit font-normal text-[1vw] text-textPrimaryColor pl-[7.5%] pt-[2.5%] pb-[5%] cursor-pointer'
										onClick={handleUserLogout}>
										Logout
									</span>
								</div>
							)}
						</div>
					) : (
						<button
							className='bg-gradient-to-r from-[#1A67D8] to-[#0047AF] font-normal text-[0.9vw] text-white border border-[#1A67D8] rounded-3xl shadow px-[3%] py-[0.9%] ml-20 hover:bg-[#0047AF] transition'
							onClick={() => setIsAuth(true)}>
							Login / Signup
						</button>
					)}
					<button
						className='flex items-center px-[2%] py-[0.9%] space-x-2 relative'
						onClick={handleCartClick}>
						<img src='/assets/cart-icon.svg' alt='cart-icon' />
						<span className='font-normal text-[0.9vw] text-textPrimaryColor'>
							Cart
						</span>
						<span className='bg-primaryColor font-normal text-[0.6vw] text-whiteColor rounded-full px-[5.5%] absolute top-1 right-[50%] z-50'>
							{isLoggedIn ? countAllCartProducts() : 0}
						</span>
					</button>
				</div>
			</div>

			{/** medium Screens */}
			<div
				className={`w-full h-fit bg-whiteColor hidden lg:flex justify-between items-center border-b px-[2%] py-[0.5%] fixed left-0 mb-2 ${scrollDirection === "up" ? "top-10" : "top-0"
					} right-0 z-50`}>
				<div className='w-[50%] h-fit flex justify-start items-center space-x-[5%]'>
					<Link to='/'>
						<img src='/assets/finelabs-logo-blue.svg' alt='finelabs-logo' />
					</Link>
					{locationVisibility && (
						<div className='w-[33%] h-fit flex flex-col justify-start items-center'>
							<div className='w-full h-9 bg-whiteColor flex justify-between items-center border-2 border-blue-300 rounded-xl px-[5%] cursor-pointer relative'>
								<div
									className='flex items-center space-x-2'
									onClick={handleLocationClick}
								>
									<img
										src='/assets/location-pin.svg'
										alt='location-pin'
										className='w-[12.5%]'
									/>
									{userLocationAddress !== "" ? (
										<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor whitespace-nowrap'>
											{userLocationAddress?.slice(0, 20)}
										</p>
									) : (
										<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor whitespace-nowrap'>
											"Select Location..."
										</p>
									)}
								</div>
								<MdKeyboardArrowDown className='text-base text-textSecondaryColor' />
								{locationCardStatus && (
									<div className='w-full h-fit bg-whiteColor border rounded-xl shadow p-[5%] absolute left-0 right-0 top-10 z-50'>
										<div
											className='w-full h-fit flex items-center space-x-2'
											onClick={handleLocationFetch}>
											<img
												src='/assets/location-arrow.svg'
												alt='location-arrow'
												className='w-[7.5%]'
											/>
											<span className='font-normal text-[4vw] lg:text-[1vw] text-accentColor'>
												Use My Current Location
											</span>
										</div>
									</div>
								)}
							</div>
						</div>
					)}
					{isSearchVisible && searchVisible && (
						<div className='w-[95%] lg:w-[45%] h-[48px] bg-whiteColor border-2 border-blue-300 rounded-[32px] flex justify-between items-center  relative'>
							<div className='flex w-full items-center ml-[2%]'>
								{productsToBeSearched.length == 0 && (
									<IoIosSearch className='text-xl text-blue-300 mr-[2%]' />
								)}
								{productsToBeSearched.length > 0 && (
									<div className='w-full h-11 ml-2 gap-y-2 gap-x-2 grid grid-cols-1 pt-2 overflow-y-scroll mr-2'>
										{productsToBeSearched.map((product, index) => (
											<div
												key={index}
												className='w-full px-2 h-[28px] rounded-[28px] bg-[#E0E0E0] flex justify-between items-center mr-2 text-[13px] text-[#57636C]'>
												<div className='w-fit truncate'>{product}</div>
												<img
													src='/assets/close-icon.svg'
													alt='close-icon'
													className='cursor-pointer ml-1 flex-shrink-0'
													onClick={() =>
														handleRemoveProductsToBeSearched(product)
													}
												/>
											</div>
										))}
									</div>
								)}
								<input
									type='text'
									value={navbarSearchQuery}
									onChange={handleSearchQueryChange}
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											navigate("/search");
										}
									}}
									placeholder='Search from 12,000+ Lab Tests, Packages, X-rays & Scans'
									className='w-[83%] h-full rounded-xl font-normal text-[14px] text-textPrimaryColor placeholder:text-[14px] outline-none'
								/>
							</div>
							<div
								className='flex justify-center items-center mr-[0.5%] text-[15px] text-white w-[120px] bg-gradient-to-r from-[#1A67D8] to-[#0047AF] h-[40px] rounded-[48px]'
								onClick={handleSearchClick}>
								Search
							</div>
							{navbarSearchQuery?.length > 0 &&
								productsBySearchQuery?.length > 0 && (
									<div className='w-full h-[33vh] bg-whiteColor  border rounded-3xl shadow py-[3%] mt-1 absolute left-0 right-0 top-14 z-50 overflow-scroll scrollbar-hide'>
										{productsBySearchQuery?.map((item, index) => (
											<div
												className='w-full h-fit flex justify-between items-center border-b px-[2%] py-[1%] cursor-pointer'
												key={index}
												onClick={() => handleAddProductsToBeSearched(item)}>
												<span className='font-normal text-[14px] text-textPrimaryColor'>
													{item}
												</span>
											</div>
										))}
									</div>
								)}
						</div>
					)}
				</div>
				<div className='w-[50%] h-fit flex justify-end items-center'>
					{linksData?.map((item, index) => (
						<Link
							to={item.link}
							key={index}
							className={`font-semibold text-[1vw] ${location.pathname === item.link
									? "text-primaryColor border-b-2 border-primaryColor"
									: "text-textPrimaryColor"
								} ml-[5%] hover:text-primaryColor hover:border-b-2 hover:border-primaryColor`}>
							{item.title}
						</Link>
					))}
					{isLoggedIn && userData?.name?.length > 0 ? (
						<div
							className='ml-[10%] relative'
							onMouseEnter={() => setProfileHovered(true)}
							onMouseLeave={() => setProfileHovered(false)}>
							<div
								className={`flex items-center space-x-2 cursor-pointer pl-1 pt-1  ${profileHovered
										? "border rounded-t-xl shadow-md"
										: "border border-white"
									}`}>
								<img
									src='/assets/user-icon.svg'
									alt='user-icon'
									className='w-9'
								/>
								<span className='font-semibold text-lg text-textPrimaryColor'>
									{userData?.name ? userData?.name.split(" ")[0] : "User"}
								</span>
								<MdKeyboardArrowDown className='text-lg text-textPrimaryColor' />
							</div>
							{profileHovered && (
								<div className='bg-whiteColor flex flex-col justify-start items-start border rounded-b-xl shadow space-y-[3%] absolute left-0 right-0 z-50'>
									<Link
										to='/my-profile'
										className='w-full h-fit font-normal text-[1vw] text-textPrimaryColor border-b pl-[7.5%] py-[5%]'>
										My Profile
									</Link>
									<Link
										to='/my-order'
										className='w-full h-fit font-normal text-[1vw] text-textPrimaryColor border-b pl-[7.5%] pt-[2.5%] pb-[5%]'>
										My Order
									</Link>
									<span
										className='w-full h-fit font-normal text-[1vw] text-textPrimaryColor pl-[7.5%] pt-[2.5%] pb-[5%] cursor-pointer'
										onClick={handleUserLogout}>
										Logout
									</span>
								</div>
							)}
						</div>
					) : (
						<button className='btn-primary' onClick={() => setIsAuth(true)}>
							Login / Signup
						</button>
					)}
					<button
						className='flex items-center px-[2%] py-[0.9%] space-x-2 relative'
						onClick={handleCartClick}>
						<img src='/assets/cart-icon.svg' alt='cart-icon' />
						<span className='font-normal text-[0.9vw] text-textPrimaryColor'>
							Cart
						</span>
						<span className='bg-primaryColor font-normal text-[0.6vw] text-whiteColor rounded-full px-[5.5%] absolute top-1 right-[50%] z-50'>
							{isLoggedIn ? countAllCartProducts() : 0}
						</span>
					</button>
				</div>
			</div>

			{/** Small Screens */}
			<div className='w-full h-fit fixed left-0 top-0 right-0 z-50 lg:hidden'>
				<div className='w-full h-fit bg-whiteColor flex justify-between items-center border-b p-[4%]'>
					<div onClick={handlePhoneFinelabsClick} className='cursor-pointer'>
						<img src='/assets/finelabs-phone-icon.svg' alt='' />
					</div>
					{!userLocationAddress && locationVisibility && (
						<div
							className='w-[170px] h-[36px] flex justify-between items-center bg-[#2673E7] rounded-[12px] px-[5%] cursor-pointer relative'
							onClick={handleLocationFetch}>
							<div className='flex items-center space-x-2 cursor-pointer'>
								<div className='flex justify-center items-center space-x-2'>
									<p className='font-normal text-[16px] text-white whitespace-nowrap'>
										Select Location
									</p>
									<MdKeyboardArrowDown className='text-base text-white' />
								</div>
							</div>
						</div>
					)}
					{/* <button
            className="text-[6vw] text-textPrimaryColor"
            onClick={handleSidebarClick}
          >
            <GiHamburgerMenu />
          </button> */}
					{/* <Link to="/">
            <img src="/assets/finelabs-logo-blue.svg" alt="finelabs-logo" />
          </Link> */}
					{/* <div className="w-[66%] h-fit flex flex-col justify-start items-center relative">
            <div
              className={`w-full h-10 bg-whiteColor flex justify-center items-center ${
                isLocationClicked && "border-2 border-blue-300 rounded-xl"
              }`}
            >
              {userLocationAddress !== "" ? 
              (<p
                className="font-normal text-[4vw] text-textSecondaryColor whitespace-nowrap"
                onClick={handleLocationClick}
              >
                {userLocationAddress?.slice(0, 20)}
              </p>) : 
              (<p
                className="font-normal text-[4vw] text-textSecondaryColor whitespace-nowrap"
                onClick={handleLocationClick}
              >
                Select Location...
              </p>)
              }
              <MdKeyboardArrowDown
                className="text-base text-textSecondaryColor ml-2"
                onClick={handleLocationClick}
              />
              {isLocationClicked && (
                <div className="h-fit bg-whiteColor border rounded-xl shadow p-[5%] absolute left-0 right-0 top-10 z-50">
                  <div
                    className="w-full h-fit flex items-center space-x-2"
                    onClick={handleLocationFetch}
                  >
                    <img
                      src="/assets/location-arrow.svg"
                      alt="location-arrow"
                      className="w-[7.5%]"
                    />
                    <span className="font-normal text-[4vw] lg:text-[1vw] text-accentColor whitespace-nowrap">
                      Use My Current Location
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div> */}

		  
					<button className='relative' onClick={handleCartClick}>
						<img src='/assets/cart-icon.svg' alt='cart-icon' />
						<span className='bg-primaryColor font-normal text-[2.5vw] text-whiteColor rounded-full px-[20%] absolute bottom-3.5 left-[60%] z-50'>
							{isLoggedIn ? countAllCartProducts() : 0}
						</span>
					</button>
				</div>
			</div>

			{isSidebar && (
				<div className='w-screen h-screen fixed left-0 top-0 right-0 bottom-0 z-50'>
					<div className='w-full h-full flex flex-col justify-start items-start bg-whiteColor animate-slideLeftToRight'>
						<div className='w-full h-fit flex justify-end items-center shadow-md p-[4%]'>
							<button
								className='text-[6vw] text-textSecondaryColor'
								onClick={handleSidebarClick}>
								<MdClose />
							</button>
						</div>
						{!isLoggedIn && (
							<div
								className='w-full h-fit p-[4%] border-b'
								onClick={() => {
									handleSidebarClick();
									setIsAuth(true);
								}}>
								<span className='font-medium text-[5vw] text-textPrimaryColor'>
									Login
								</span>
							</div>
						)}
						{isLoggedIn &&
							loggedInLinksData?.map((item, index) => (
								<Link
									to={item.link}
									key={index}
									onClick={handleSidebarClick}
									className={`w-full h-fit p-[4%] border-b font-medium text-[5vw] ${location.pathname === item.link
											? "text-primaryColor"
											: "text-textPrimaryColor"
										}`}>
									{item.title}
								</Link>
							))}
						{linksData?.map((item, index) => (
							<Link
								to={item.link}
								key={index}
								onClick={handleSidebarClick}
								className={`w-full h-fit p-[4%] border-b font-medium text-[5vw] ${location.pathname === item.link
										? "text-primaryColor"
										: "text-textPrimaryColor"
									}`}>
								{item.title}
							</Link>
						))}
						{isLoggedIn && (
							<div className='w-full h-fit p-[4%] border-b'>
								<span
									className='font-medium text-[5vw] text-textPrimaryColor'
									onClick={() => {
										handleUserLogout();
										handleSidebarClick();
									}}>
									Logout
								</span>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default Navbar;
